<div class="title-row">
  <span class="title-text">{{ title() }}</span>
  <ng-content select="[actions]"></ng-content>
</div>
@if (description()) {
  <div class="description">{{ description() }}</div>
}
<div class="content">
  <ng-content select="[content]"></ng-content>
</div>
